package com.patronat.top.features.venues.domain.usecase.command

data class GetSubmittedVenueDraftCommand(
    val venueId: String
)
